import { render } from "./Banner.vue?vue&type=template&id=5077c180&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=5077c180&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5077c180"]])

export default __exports__